import React from 'react';
import PropTypes from 'prop-types';

import { Panel, PanelHeader, H3, PanelBody } from '@studio/legacy-components';
import { ConditionsShape } from 'next/entities/rules';

import TestUrlModalManager from './TestUrlModalManager';
import Path from './Path';
import Environment from './Environment';

export default function UrlTargeting({
  urlConditions,
  domainConditions,
  onUrlConditionChange,
  onDomainConditionChange,
}) {
  return (
    <Panel>
      <PanelHeader>
        <H3>URL Targeting</H3>
        <TestUrlModalManager
          conditions={{
            and: [urlConditions, domainConditions].filter(Boolean),
          }}
        />
      </PanelHeader>
      <PanelBody>
        <Path conditions={urlConditions} onChange={onUrlConditionChange} />
        <Environment
          conditions={domainConditions}
          onChange={onDomainConditionChange}
        />
      </PanelBody>
    </Panel>
  );
}

UrlTargeting.propTypes = {
  urlConditions: ConditionsShape,
  domainConditions: ConditionsShape,
  onUrlConditionChange: PropTypes.func,
  onDomainConditionChange: PropTypes.func,
};
